import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  controllerCode: "",
  customerScope: "",
  contentLibraryDetails: [], 
};

const contentLibrarySlice = createSlice({
    name: "contentLibrary",
    initialState,
    reducers: {
        setControllerCodes: (state, action) => {
            state.controllerCode = action.payload
        },
        setCustomerScopes: (state, action) => {
            state.customerScope = action.payload
        },
        addContentLibraryDetails: (state, action) => {
            state.contentLibraryDetails = action.payload;
        },
    },
});

export const { setControllerCodes, setCustomerScopes, addContentLibraryDetails } = contentLibrarySlice.actions;
export default contentLibrarySlice.reducer;
